<template>
  <div class="percent-indicator">
    <svg
      width="133"
      height="133"
      viewBox="0 0 133 133"
      xmlns="http://www.w3.org/2000/svg"
      style="overflow: visible"
    >
      <defs>
        <!-- 三色漸層 -->
        <linearGradient
          id="gradient"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="133"
          x2="0"
          y2="0"
        >
          <stop offset="0%" stop-color="#F8B9E5" />
          <stop :offset="`50%`" stop-color="#FDB08D" />
          <stop :offset="`100%`" stop-color="#F9F6A2" />
        </linearGradient>

        <!-- 擴大範圍的 drop-shadow filter -->
        <filter
          id="filter0_ddd"
          x="-30"
          y="-30"
          width="193"
          height="193"
          filterUnits="userSpaceOnUse"
        >
          <feFlood flood-opacity="0" result="BG" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0   0 0 0 127 0"
            result="HA"
          />
          <feOffset dx="3" dy="3" />
          <feGaussianBlur stdDeviation="3.87" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0   0 0 0 0.2 0"
          />
          <feBlend in2="BG" mode="normal" result="drop1" />

          <feOffset dx="-1.55" dy="-1.55" />
          <feGaussianBlur stdDeviation="1.55" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1   0 0 0 1 0"
          />
          <feBlend in2="drop1" mode="normal" result="drop2" />

          <feBlend in="SourceGraphic" in2="drop2" mode="normal" />
        </filter>
      </defs>

      <!-- 底層外框 + 陰影 (fill) -->
      <g filter="url(#filter0_ddd)">
        <path :d="originalPath" fill="#FDFEFE" />
      </g>

      <!-- 進度：沿著外框中線 (transform hack) -->
      <g
        :transform="`translate(${center.x},${
          center.y
        }) scale(${scale}) translate(${-center.x},${-center.y})`"
      >
        <path
          :d="targetPath"
          fill="none"
          stroke="url(#gradient)"
          stroke-width="8"
          stroke-linecap="round"
          vector-effect="non-scaling-stroke"
          :stroke-dasharray="getStrokeDashArray(animatedPercentage)"
          style="transition: stroke-dasharray 1s ease-in-out"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "PercentIndicator",
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      animatedPercentage: 0,
      pathLength: 0,
      center: { x: 66.5, y: 66.5 },
      scale: 0.94,
      originalPath: `M26.7386 111.264C25.2488 112.753 22.8237 112.761 21.4258 111.184C13.8465 102.636 8.69371 92.1835 6.5442 80.9154C4.15589 68.3954 5.58545 55.4466 10.6474 43.7492C15.7093 32.0517 24.17 22.1456 34.9315 15.3161C45.6931 8.48658 58.2588 5.04899 70.9983 5.44934C83.7377 5.8497 96.0628 10.0695 106.374 17.5613C116.686 25.053 124.508 35.4709 128.825 47.4631C133.143 59.4553 133.756 72.4683 130.587 84.8136C127.734 95.9244 121.935 106.033 113.834 114.088C112.34 115.574 109.92 115.414 108.526 113.834C107.133 112.253 107.295 109.851 108.777 108.354C115.737 101.319 120.724 92.5452 123.196 82.9161C125.986 72.0522 125.446 60.6008 121.646 50.0476C117.847 39.4945 110.964 30.3268 101.889 23.734C92.8154 17.1413 81.9693 13.4279 70.7586 13.0756C59.5479 12.7232 48.4901 15.7483 39.0199 21.7583C29.5497 27.7682 22.1043 36.4857 17.6498 46.7794C13.1953 57.0732 11.9373 68.4681 14.039 79.4856C15.9019 89.251 20.3279 98.3204 26.8325 105.778C28.2174 107.366 28.2285 109.774 26.7386 111.264Z`,
      targetPath: `M21.4258 111.184C13.8465 102.636 8.69371 92.1835 6.5442 80.9154C4.15589 68.3954 5.58545 55.4466 10.6474 43.7492C15.7093 32.0517 24.17 22.1456 34.9315 15.3161C45.6931 8.48658 58.2588 5.04899 70.9983 5.44934C83.7377 5.8497 96.0628 10.0695 106.374 17.5613C116.686 25.053 124.508 35.4709 128.825 47.4631C133.143 59.4553 133.756 72.4683 130.587 84.8136C127.734 95.9244 121.935 106.033 113.834 114.088`,
    };
  },
  methods: {
    measurePathLength() {
      const svgNS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNS, "svg");
      const path = document.createElementNS(svgNS, "path");
      path.setAttribute("d", this.originalPath);
      svg.appendChild(path);
      document.body.appendChild(svg);
      this.pathLength = path.getTotalLength();
      document.body.removeChild(svg);
    },
    getStrokeDashArray(percent) {
      if (!this.pathLength) return "0 1000";
      const usable = this.pathLength * 0.432;
      const fillLen = (usable * percent) / 100;
      return `${fillLen} ${this.pathLength * 10}`;
    },
  },
  watch: {
    percentage(val) {
      this.animatedPercentage = val;
    },
  },
  mounted() {
    this.measurePathLength();
    this.animatedPercentage = this.percentage;
  },
};
</script>

<style scoped>
.percent-indicator {
  width: 120px;
  height: 120px;
}
</style>
